import "../Static Files/styles/sidebar/sidebar.css";
import { NavLink } from "react-router-dom";
import logo from "../Static Files/Images/HomePage/Logo Transparent.png";
import { useEffect, useState } from "react";
import ArrowIcon from "./arrowIcon";
import { useSelector } from "react-redux";  // Redux store'dan məlumatları alacaq
import * as signalR from "@microsoft/signalr";

const AdminNavbar = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [count,setCount]=useState(true);
  const { pendingRequests,length } = useSelector((state) => state.requests); // Requests'dən məlumatı alırıq

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

    useEffect(() => {
      const connection = new signalR.HubConnectionBuilder()
        .withUrl("https://localhost:7089/tourRequestHub", {
          withCredentials: true,
        })
        .withAutomaticReconnect()
        .build();
  
      connection
        .start()
        .then(() => console.log("SignalR connection established"))
        .catch((err) => console.error("SignalR ayeee failed", err));
  
      connection.on("ReceiveTourRequest", (name, email, phone,tourId) => {
        setCount(true);
      });
    });

  

  return (
    <div className={`sidebar ${isOpen ? "open" : "closed"}`}>
      <div className="brand-div">
        <img src={logo} alt="Logo" />
        <NavLink className="link" to="/">
          <h3 className="first-text">Joyful</h3>
          <h3 className="second-text">Travel</h3>
        </NavLink>
      </div>
      <ul>
        {/* <li>
          <i class="fa-solid fa-table-columns"></i>
          <NavLink to="/az/admin/" className="sidebar-link">
            İdarəetmə menyusu
          </NavLink>
        </li> */}
        <li>
          <i class="fa-solid fa-user"></i>
          <NavLink to="/admin/users" className="sidebar-link">
            İstifadəçilər
          </NavLink>
        </li>
        <li>
          <i class="fa-solid fa-list"></i>
          <NavLink to="/admin/tours" className="sidebar-link">
            Turlar
          </NavLink>
        </li>
        {/* <li>
        <i class="fa-solid fa-house"></i>
          <NavLink to="/az/admin/aframes" className="sidebar-link">
            Aframe
          </NavLink>
        </li> */}
        <li>
          <i class="fa-solid fa-blog"></i>
          <NavLink to="/admin/blogs" className="sidebar-link">
            Bloqlar
          </NavLink>
        </li>
        <li>
          <i class="fa-solid fa-message"></i>
          <NavLink to="/admin/requests" className="sidebar-link">
            Tur istəkləri
            {/* Yeni gələn istəklərin sayını göstəririk */}
            {count && <span className="request-count">{pendingRequests.length}</span>}
          </NavLink>
        </li>
        <li>
          <i class="fa-solid fa-address-book"></i>
          <NavLink to="/admin/contacts" className="sidebar-link">Əlaqə</NavLink>
        </li>
        <li>
          <i class="fa-solid fa-gears"></i>
          <NavLink className="sidebar-link">Parametrlər</NavLink>
        </li>
      </ul>
    </div>
  );
};

export default AdminNavbar;
